import Vue from 'vue';
import Router from 'vue-router';
import i18n from './i18n';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'home-it',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      beforeEnter: (to, from, next) => {
        i18n.locale = 'it';
        process.env.LOCALE = 'it';
        next();
      },
    },
    {
      path: '/en',
      name: 'home-en',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      beforeEnter: (to, from, next) => {
        i18n.locale = 'en';
        process.env.LOCALE = 'en';
        next();
      },
    },
  ],
});
